import { useRouter } from "next/router";

import { useTranslation } from "../../core/translation.core";
import PosLayout from "../layouts/posLayout.comp";
import CartPanel from "../newOrders/CartPanel.comp";
import HeldCartPanel from "../newOrders/HeldCartPanel.comp";

export default function OrderPanelLayout({ children }: { children: React.ReactNode }) {
  const { msg, t } = useTranslation();
  const { query } = useRouter();

  return (
    <PosLayout title={t(msg.posMenuItems.newOrder)} noPadding>
      <main className="block lg:grid grid-cols-8">
        <div className="space-y-8 p-4 col-span-5 h-[90vh] overflow-y-auto">{children}</div>

        <div className="hidden lg:block col-span-3">{query.mode !== "heldCart" ? <CartPanel /> : <HeldCartPanel />}</div>
      </main>
    </PosLayout>
  );
}
